import { getDependencies, loadMicrofrontend, serializeProps } from '../lib/index.js';
const pendingRenders = new Map();
export async function renderMicrofrontend(instanceId, server, props, options) {
    const placeholder = document.querySelector(`[data-mf-id="${instanceId}"][data-mf-role="placeholder"]`);
    if (!placeholder) {
        return Promise.reject(new Error(`Failed to find placeholder for '${instanceId}'`));
    }
    const renderKey = Object.values(serializeProps(props)).join();
    const pending = pendingRenders.get(renderKey);
    if (pending) {
        return pending;
    }
    const render = async () => {
        const resp = await loadMicrofrontend(server, props, options);
        const [content] = await Promise.allSettled([resp.text(), loadDependencies(resp.headers.get('Link'))]);
        if (content.status === 'fulfilled') {
            const fragment = document.createRange().createContextualFragment(content.value);
            placeholder.replaceChildren(fragment);
        }
        return placeholder;
    };
    const promise = render().finally(() => pendingRenders.delete(renderKey));
    pendingRenders.set(renderKey, promise);
    return promise;
}
export function unmountMicrofrontend(placeholder) {
    placeholder.querySelectorAll('astro-island').forEach(elem => {
        const island = elem;
        island.unmount?.();
    });
}
async function loadDependencies(linkHeader) {
    const { styles, scripts } = getDependencies(linkHeader);
    const promises = [];
    styles.forEach(style => {
        promises.push(loadStyle(style));
    });
    scripts.forEach(script => {
        promises.push(loadScript(script));
    });
    await Promise.all(promises);
}
async function loadStyle(url) {
    return new Promise(resolve => {
        const link = document.createElement('link');
        link.href = url;
        link.rel = 'stylesheet';
        link.crossOrigin = 'anonymous';
        link.onload = () => resolve();
        document.head.appendChild(link);
    });
}
async function loadScript(url) {
    return new Promise(resolve => {
        const script = document.createElement('script');
        script.src = url;
        script.type = 'module';
        script.crossOrigin = 'anonymous';
        script.onload = () => resolve();
        document.body.appendChild(script);
    });
}
